<template>
    <div>
        <app-list
            :data-source="'tecpage.user.modules.' + moduleId + '.data.texts'"
            :data-preset="false"
            :data-name="'data.title'"
            :data-subtitle="'data.subtitle'"
            :data-text="'data.text'"
            :data-flexible="true"
            :list-label="'Text'"
            :list-subpage="'Texts'"
            :allow-individual="true"
            :label="'Text'"
        ></app-list>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import List from '@/components/fields/complex/List.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R093'),
            removeText: this.$helpers.uiText('R064'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-list': List
    }
};
</script>
